import { Box, List, ListItem, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import { locations } from 'services/routes/locations';
import theme from 'theme';
import general from 'services/locales/en/general';
import useStyles from '../style';
import LegalExternalLinks from './LegalExternalLinks';
import AboutUsExternalLinks from './AboutUsExternalLinks';
import { StyledLegalLink } from './styled';

const PageLinks = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  const currentYear = new Date().getFullYear();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        width: isMobile ? '100%' : '85%',
        alignItems: 'start',
        justifyContent: 'space-around',
      }}
    >
      <Box className={`${classes.legalLinks} ${classes.textBox}`}>
        <List>
          <Box className={classes.title}>
            {/* @ts-ignore */}
            <Typography variant="bodyGrey">
              {t(general.footer.loudly)}
            </Typography>
          </Box>
          <ListItem>
            <Typography
              variant="caption"
              component={Link}
              to={locations.general.aiMusicGenerator.pathname}
            >
              {t(general.sideBar.links.create)}
            </Typography>
          </ListItem>
          <>
            <ListItem>
              <Typography
                variant="caption"
                component={Link}
                to={locations.general.discovery.pathname}
              >
                {t(general.sideBar.links.discover)}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography
                variant="caption"
                component={Link}
                to={locations.general.songList}
              >
                {t(general.sideBar.links.templates)}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography
                variant="caption"
                component={Link}
                to={locations.subscription.pricing.pathname('')}
              >
                {t(general.sideBar.links.pricing)}
              </Typography>
            </ListItem>
          </>
        </List>
      </Box>
      <Box className={`${classes.legalLinks} ${classes.textBox}`}>
        <List>
          <Box className={classes.title}>
            {/* @ts-ignore */}
            <Typography variant="bodyGrey">
              {t(general.footer.aboutUs.title)}
            </Typography>
          </Box>

          <AboutUsExternalLinks />
        </List>
      </Box>
      <Box className={`${classes.legalLinks} ${classes.textBox}`}>
        <List>
          <Box className={classes.title}>
            {/* @ts-ignore */}
            <Typography variant="bodyGrey">
              {t(general.footer.legal)}
            </Typography>
          </Box>
          <LegalExternalLinks />
        </List>
      </Box>
      <StyledLegalLink>
        <Typography variant="caption" sx={{ color: theme.palette.grey[400] }}>
          {t(general.footer.copyright, { year: currentYear })}
        </Typography>
      </StyledLegalLink>
    </Box>
  );
};

export default PageLinks;
